<template lang="pug">
.fillblank
  Form(:model="question" label-position="right")
    .question-stem
      FormItem
        //- span(style="float:left;width:20px; height:32px; line-height:32px;font-size:14px") 3.
        Input(placeholder="题目内容",v-model='question.stem' :maxlength="50")
      iDelModel(:del-model='delModel',@upData="$emit('upData')",@downData="$emit('downData')")
      template
        Row(v-for="(item,index) in question.metas.infoData" :key="index")
          Col(span="16")
            FormItem(:label='`资料${index+1}`' :label-width="80")
              Input.steminp(placeholder="资料",v-model='item.title' :maxlength="20")
          Col(v-if="index == question.metas.infoData.length-1 && index != 0" span="6")
            Button(type="error" shape="circle" icon="md-close" @click="handleDelInfo('info',index)")
      FormItem(label='' :label-width="80")
        Button(type="primary" icon="md-add" ghost @click="handleAddInfo('info')") 添加
      template
        Row(v-for="(item,index) in question.metas.taData" :key="item.key")
          Col(span="16")
            FormItem(:label='`第${index+1}列`' :label-width="80")
              Select(placeholder="请选择" v-model='item.tag' multiple)
                Option(v-for="val in question.metas.infoData" :value="val.title" :key="val.key" :disabled='question.metas.taData.flatMap((item) => item.tag).includes(val.title)') {{ val.title }}
          Col(v-if="index == question.metas.taData.length-1 && index != 0" span="6")
            Button(type="error" shape="circle" icon="md-close" @click="handleDelInfo('ta',index)")
      FormItem(label='' :label-width="80")
        Button(type="primary" icon="md-add" ghost @click="handleAddInfo('ta')") 添加
      div(style="background:#ccc;padding:10px;border-radius:4px;")
        Row
          Col(v-for="(item,index) in question.metas.taData" :key="item.title" :span="24/question.metas.taData.length")
            FormItem(style="" :label='`第${index+1}列`')
                RadioGroup(vertical v-model="item.allTag")
                  Radio(v-for="app in item.tag" :key="app" :label="app")
                    span {{ app }}
        Button(type="primary" @click="handleSetTag") 确定
      FormItem(label='参考答案' :label-width="80")
        <div style="">
          <Tag v-for="(item,index) in question.metas.taList" :key="item" type="border" closable @on-close="(e)=>handleCloseTa(e,index)">{{ item }}</Tag>
        </div>
      FormItem(label='分值' :label-width="80")
        InputNumber(:max="100" :min="0" v-model="question.score")
</template>

<script>
import iTag from "@/components/common/iTag";
import iDelModel from "@/components/common/iDelModel";
import isEditTips from "@/components/common/iEditTips";
export default {
  components: {
    iTag,
    iDelModel,
    isEditTips
  },
  props: ["data"],
  data() {
    return {
      question: {
        stem: "",
        metas: {
          infoData: [{ title: "", key: "a" }],
          taData: [{ tag: [], allTag: "" }],
          taList: []
        },
        score: 0
      },
      isEditTips: false
      // question: {
      //   stem: "",
      //   tips: "",
      //   isShow: false,
      //   metas: [],
      //   scoringKeywords: [],
      //   analysis: "",
      //   score: 0,
      //   value: 1
      // }
    };
  },
  methods: {
    async handleSetTag() {
      if (
        this.question.metas.taList.includes(
          this.question.metas.taData.map((v) => v.allTag).join(",")
        )
      ) {
        this.$Message.error("不能添加相同的线！");
        return;
      }
      await this.question.metas.taList.push(
        this.question.metas.taData.map((v) => v.allTag).join(",")
      );
      this.question.metas.taData.forEach((el) => {
        el.allTag = "";
      });
    },
    handleCloseTa(e, index) {
      this.question.metas.taList = this.question.metas.taList.filter((v, i) => i !== index);
    },
    handleDelInfo(type, index) {
      if (type === "info") {
        this.question.metas.infoData = this.question.metas.infoData.filter((val, i) => i !== index);
      } else {
        this.question.metas.taData = this.question.metas.taData.filter((val, i) => i !== index);
      }
    },
    handleAddInfo(type) {
      if (type === "info") {
        if (this.question.metas.infoData.length === 50) {
          this.$Message.error("最多添加50条！");
          return;
        }
        this.question.metas.infoData.push({
          title: "",
          key: Math.floor(Math.random() * 1000000).toString()
        });
      } else {
        if (this.question.metas.taData.length === 5) {
          this.$Message.error("最多添加5列！");
          return;
        }
        this.question.metas.taData.push({ tag: [], allTag: "" });
      }
    },
    editTips() {
      // 编辑提示
      this.isEditTips = !this.isEditTips;
    },
    // 删除
    delModel() {
      this.$emit("delModel");
    },
    // 复选框状态
    changebox() {
      this.question.score = 0;
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (Object.keys(this.data).length !== 0) {
        this.question = this.data;
      }
      //   this.$emit("data1:data", this.question);
    });
  },
  watch: {
    question: {
      handler(val) {
        if (JSON.stringify(val) !== JSON.stringify(this.data)) {
          this.$emit("data1:data", val);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    data: {
      handler(val) {
        if (JSON.stringify(val) !== "{}") this.question = val; // 更新本地变量
      },
      immediate: true,
      deep: true
    }
  },
  created() {
    // this.$emit("data1:data", this.question);
    //   this.$nextTick(() => {
    //     this.from = this.parent.Case.basic;
    //   });
  }
};
</script>
<style lang="stylus" scoped>
.fillblank
  width 790px
  padding 24px 16px 24px 44px
  .question-stem
    .steminp
      /deep/ .ivu-input-default
        margin 0
    position relative
    .ivu-form-item-content
      width 75%
  .checkbox
    width 100%
    height 50px
    padding-left 85px
  .explain
    width 100%
    height 100px
    background rgba(255, 255, 255, 1)
    border-radius 4px
    border 1px solid rgba(210, 221, 236, 1)
    resize none
    outline none
    font-size 14px
    font-family MicrosoftYaHeiUI
    color rgba(42, 46, 54, 0.75)
    line-height 18px
    padding 5px
</style>
